import { render, staticRenderFns } from "./TableValuesBeneficiary.vue?vue&type=template&id=95b78674&scoped=true&"
import script from "./TableValuesBeneficiary.vue?vue&type=script&lang=js&"
export * from "./TableValuesBeneficiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b78674",
  null
  
)

export default component.exports